import {Address} from "./address";
import {BaseModel} from "./base-model";

export class Company extends BaseModel {

  protected self = Company;

  id: string;
  name : string;
  location : Address;
  logoUrl : string;
  vat : string;

  public validate(): boolean {
    return true;
  }
}
